import { GlobalStoreCtx } from '@/stores/GlobalStore';
import { IToastItem } from '@/stores/partial/ToastStore';
import clsx from 'clsx';
import React, { useContext, useEffect, useState } from 'react';

import styles from './ToastItem.module.scss';
import ToastContainerStyles from '../Toast.module.scss';

interface IToastItemProps {
  item: IToastItem;
}

const ToastItem: React.FC<IToastItemProps> = ({ item }) => {
  const globalStore = useContext(GlobalStoreCtx);
  const [mounted, setMounted] = useState(false);

  const dismiss = (): void => {
    item.timer && window.clearTimeout(item.timer);
    setMounted(false);
    window.setTimeout(() => globalStore.toast.clearItem(item), 250);
  };

  useEffect(() => {
    window.setTimeout(() => setMounted(true), 10);
    item.timer = window.setTimeout(dismiss, item.timeout);
  }, []);

  return (
    <div className={ToastContainerStyles.container} style={item.style}>
      <div className={clsx(styles.item, mounted && styles.itemMounted)} onClick={dismiss}>
        <div className={styles.wrapper}>{item.text}</div>
      </div>
    </div>
  );
};
export default ToastItem;
